import React       from 'react'
import { store }   from 'index'
import { objType } from 'types';

const useScrollIntoView = (
    val:     objType,
    UnitRef: any
) => {

    React.useEffect(() => {

        const state     = store.getState();
        const manualVal = state.manualNav.manualVal;

        const tag = `${  val.app ? val.app : '' }${ val.uid ? `${ val.uid }` : val.lesson_id }`
   
        const scrollIntoView  = ( manualVal === tag || manualVal === `${ tag }###score` ||  manualVal === `${ tag }###description`);
  
        if (UnitRef && UnitRef.current && scrollIntoView ) {
    
          UnitRef.current.scrollIntoView();
         // setManualSelect(ind);
        }
            
    },[UnitRef, val])

}

export default useScrollIntoView
